/* unplugin-vue-components disabled */import script from "./infoList.vue?vue&type=script&setup=true&lang=js"
export * from "./infoList.vue?vue&type=script&setup=true&lang=js"

import "./infoList.vue?vue&type=style&index=0&id=25f7e8ca&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f7e8ca"]])

export default __exports__